import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {TourService} from '../services/tour.service';
import {ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {TourApiService} from '../services/tour-api.service';
import {Tour} from '../model/tour';
import {AboutInfo} from '../model/about-info';
import {CommunityInfo} from '../model/community-info';
import {Scene} from '../model/scene';
import {MicroApiService} from '../services/micro-api.service';
import {TrackingService} from '../services/tracking.service';
import {ModalService} from '../services/modal.service';
import {EnumAware} from '../decorators/enum-aware.decorator';
import {ImageListComponent} from '../shared/image-list.component';
import {OptionDetailService} from '../services/option-detail.service';

@EnumAware
@Component({
  selector: 'gt-shared-wishlist',
  templateUrl: './shared-wishlist.component.html',
  styleUrls: ['./shared-wishlist.component.css', './tour.component.css', './option-detail.component.css']
})
export class SharedWishlistComponent implements OnInit, OnDestroy {

  private subscription: Subscription;
  tourLoaded = false;
  aboutHomeInfo: AboutInfo;
  communityInfo: CommunityInfo;
  wishlistScenes: Scene[] = [];
  errorMessage: string;
  @ViewChild(ImageListComponent)
  private imageListComponent: ImageListComponent;
  constructor(public tourApiService: TourApiService,
              public trackingService: TrackingService,
              public modalService: ModalService,
              public tourService: TourService,
              private microService: MicroApiService,
              private route: ActivatedRoute,
              public optionDetailService: OptionDetailService) { }

  ngOnInit() {

    this.tourLoaded = false;

    this.subscription = this.route.params.subscribe(
      (params: any) => {
        if (params['builder'] && params['model'] && params['wishlistkey']) {

          this.tourApiService.fetchMainTourInfoForSharedWishList(params['builder'], params['model']).subscribe(
            data => {
              this.tourService.tour = new Tour(data['results']);
              this.tourLoaded = true;

              this.microService.fetchStoredPublicData(params['wishlistkey']).subscribe(
                kvData => {
                  this.wishlistScenes = [];
                  const dataString = kvData['results'];
                  const jsonParse = JSON.parse(dataString.data);
                  for (const scene of jsonParse) {
                    this.wishlistScenes.push(Scene.fromJSON(scene));
                  }
                },
                error => {
                  console.log(error);
                  this.errorMessage = '<i class="fa fa-exclamation-circle"></i>  ' +
                                      'Oops, we couldn\'t find this shared Wish List.  ' +
                                      'Perhaps it expired.<br/>Please check the code and try again.';
                  this.wishlistScenes = [];
                }
              );

              if (this.tourService.tour.features.about.enabled) {
                this.tourApiService.fetchAboutInfo().subscribe(
                  aboutData => {
                    this.aboutHomeInfo = new AboutInfo(aboutData['results']);
                    this.imageListComponent.imageList = this.aboutHomeInfo.images;
                    this.imageListComponent.currentImage = this.imageListComponent.imageList[0];
                  },
                  error => {
                    console.log(error);
                  });
              }

              if (this.tourService.tour.features.community.enabled) {
                this.tourApiService.fetchCommunityInfo().subscribe(
                  commData => {
                    this.communityInfo = new CommunityInfo(commData['results']);
                  },
                  error => {
                    console.log(error);
                  }
                );
              }
            },
            error => {
              console.log(error);
            });
        }
    });
  }

  showGoTour() {
    const url = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port
              + '/' + this.tourApiService.builderPath + '/' + this.tourApiService.modelPath;
    window.open(url);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/shared-wishlist.component.ts